define('drops/drawings/flow/segment',['jquery', 'lq/drop'],
    function ($, Drop) {
        'use strict';
        
        function Segment() {
            var self = this;
            Drop.call(this, $('<div/>'), {});

            self.$arrow = $('<div/>')
                .addClass('bp-flow-arrow')
                .hide();

            self.$text = $('<div/>')
                .text("")
                .addClass('bp-flow-text')
                .hide();
            self.$textContainer = $('<div/>')
                .addClass('bp-flow-textcontainer')
                .append(self.$text);

            self.$line = $('<div/>')
                .addClass('bp-flow')
                .append(self.$arrow);

            self.$element
                .append(self.$line)
                .append(self.$textContainer);
        }

        Drop.extend(Segment, Drop);

        Segment.prototype.showArrow = function () {
            var self = this;
            self.$arrow.show();
        };

        Segment.prototype.showText = function (text) {
            var self = this;
            self.$text.text(text).show();
        };

        Segment.prototype.setTextPosition = function (point) {
            var self = this;
            self.$textContainer
                .css('top', point.y + 'px')
                .css('left', point.x + 'px');
        };

        Segment.prototype.draw = function () {
            var self = this;
            function drawLine(ax, ay, bx, by) {
                var angle = (Math.atan2((ax - bx), (by - ay))) * 180 / Math.PI;
                var length = Math.sqrt((ax - bx) * (ax - bx) + (ay - by) * (ay - by));
                self.$line
                    .css('height', length  + 'px')
                    .css('transform', 'rotate(' + angle + 'deg)')
                    .css('-ms-transform', 'rotate(' + angle + 'deg)')
                    .css('transform-origin', '50% 0%')
                    .css('-moz-transform', 'rotate(' + angle + 'deg)')
                    .css('-moz-transform-origin', '50% 0%')
                    .css('-webkit-transform', 'rotate(' + angle + 'deg)')
                    .css('-webkit-transform-origin', '50% 0%')
                    .css('-o-transform', 'rotate(' + angle + 'deg)')
                    .css('-o-transform-origin', '50% 0%');

                self.$element
                    .css('position', 'absolute')
                    .css('top', ay + 'px')
                    .css('left', ax + 'px');
            }

            drawLine(self.startPoint.x, self.startPoint.y, self.endPoint.x, self.endPoint.y);
        };

        return Segment;
    });
